import React, { useCallback, useEffect, useState } from 'react';
import { Button, Input, message, Popconfirm, Space, Table } from 'antd';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint'; // Ant Design'dan ekran boyutlarını almak için

const { Search } = Input;

const CompletedSupport = () => {
  const [dataSource, setDataSource] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;
  const screens = useBreakpoint(); // Ekran genişliğini almak için

  const columns = [
    {
      title: 'İsim',
      dataIndex: 'firstName',
      key: 'firstName',
      render: (name) => <b>{name}</b>,
      responsive: ['xs', 'sm', 'md', 'lg'],
    },
    {
      title: 'Soy İsim',
      dataIndex: 'lastName',
      key: 'lastName',
      render: (lastName) => <b>{lastName}</b>,
      responsive: ['md', 'lg'], // Orta ve büyük ekranlarda göster
    },
    {
      title: 'Talep',
      dataIndex: 'message',
      key: 'message',
      render: (text) => <p>{text.slice(0, 20)}...</p>,
      responsive: ['sm', 'md', 'lg'],
    },
    {
      title: 'Blok',
      dataIndex: 'blockNum',
      key: 'blockNum',
      responsive: ['md', 'lg'],
    },
    {
      title: 'Telefon',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      responsive: ['lg'], // Sadece büyük ekranlarda göster
    },
    {
      title: 'Talep Tarihi',
      dataIndex: 'repairDate',
      key: 'repairDate',
      responsive: ['md', 'lg'],
    },
    {
      title: 'Başlangıç Saati',
      dataIndex: 'startTime',
      key: 'startTime',
      responsive: ['lg'],
    },
    {
      title: 'Bitiş Saati',
      dataIndex: 'endTime',
      key: 'endTime',
      responsive: ['lg'],
    },
    {
      title: 'Durum',
      dataIndex: 'durum',
      key: 'durum',
      render: () => <p style={{ color: 'green' }}>Tamamlandı</p>,
      responsive: ['sm', 'md', 'lg'],
    },
    {
      title: 'Aksiyonlar',
      dataIndex: 'aksiyonlar',
      key: 'aksiyonlar',
      render: (_, record) => (
        <Space size={'middle'}>
          <Popconfirm
            title="Kategori Sil"
            description="Kategoriyi silmek istediğinizden emin misiniz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => deleteSupport(record.id)}
          >
            <Button type='primary' danger>Sil</Button>
          </Popconfirm>
        </Space>
      ),
      responsive: ['xs', 'sm', 'md', 'lg'], // Her ekranda göster
    },
  ];

  const fetchSupport = useCallback(async () => {
    try {
      const response = await fetch(`${apiUrl}/api/support`);
      if (response.ok) {
        const data = await response.json();
        const completedSupport = data
          .filter((req) => req.status === true)
          .sort((a, b) => {
            const dateA = new Date(a.repairDate);
            const dateB = new Date(b.repairDate);
            if (dateB - dateA !== 0) {
              return dateB - dateA; 
            }
            return b.startTime.localeCompare(a.startTime); 
          });
  
        setDataSource(completedSupport);
        setFilteredData(completedSupport);
      } else {
        message.error("Server Hatası Kullanıcılar Getirilemedi");
      }
    } catch (error) {
      console.log(error);
    }
  },[apiUrl]);

  const deleteSupport = async (supportId) => {
    try {
      const response = await fetch(`${apiUrl}/api/support/${supportId}`, {
        method: 'DELETE',
      });
      if (response.ok) {
        fetchSupport();
        message.success("Destek talebi başarıyla silindi.");
      } else {
        message.error("Destek talebi silinirken bir hata oluştu.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearch = (value) => {
    setSearchText(value);
    const filtered = dataSource.filter(
      (item) =>
        item.firstName.toLowerCase().includes(value.toLowerCase()) ||
        item.lastName.toLowerCase().includes(value.toLowerCase()) ||
        item.message.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  useEffect(() => {
    fetchSupport();
  }, [fetchSupport]);

  return (
    <>
      <Search
        placeholder="İsim, Soy İsim veya Talep ara"
        allowClear
        onChange={(e) => handleSearch(e.target.value)}
        style={{ width: screens.xs ? '100%' : 300, marginBottom: 16 }}
      />
      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey='id'
        scroll={{ x: 'max-content' }} // Küçük ekranlarda yatay kaydırmayı etkinleştir
      />
    </>
  );
};

export default CompletedSupport;
